import { slice } from './slice';
export const getAccountState = (state)=>state.account;
export const { set } = slice.actions;
export const accountReducer = slice.reducer;
export * from './actions';
